import { LargeHeadingStyled } from "src/components/custom/texts/texts.styled";
import { LostSVG } from "src/assets";
import React, { useState, useEffect } from "react";
import { Image, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import { Button } from "@nubeteck/components";
import { useLocale } from "src/i18n/localeContext";
import {getHomeAutoservicioPage} from "src/Api/content";
import { StrapiError } from "src/pages/StrapiError";

function NotFound() {
  const navigate = useNavigate();
  const { locale } = useLocale();
  const [homeAutoservicioPage, setHomeAutoservicioPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);
  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setHomeAutoservicioPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    getHomeAutoservicioPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setHomeAutoservicioPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setHomeAutoservicioPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setHomeAutoservicioPage(null);
      }}
    />;
  }
  if (isLoadingContent) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "90vh", gap: "15px" }}>
        <Skeleton.Input active size="default" style={{ width: 100 }} />
        <Skeleton.Input active size="default" style={{ width: 100 }} />
        <Skeleton.Input active size="default" style={{ width: 100 }} />
      </div>
    );
  }
  return (
    <div
      style={{
        display: "flex",  
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "90vh",
        gap: "15px",
      }}
    >
      <Image width={500} src={LostSVG} preview={false} />
      <LargeHeadingStyled>{homeAutoservicioPage?.not_found_title || "Página no encontrada"}</LargeHeadingStyled>
      <Button type="primary" onClick={() => navigate("/")}>
        {homeAutoservicioPage?.back_homepage_button || "Volver a la página principal"}
      </Button>
    </div>
  );
}

export default NotFound;
